import Fetch from '../utils/fetch';
import { settings } from '../settings';

export interface CourierDailyRating {
  positiveRatingsCount: number;
  neutralRatingsCount: number;
  negativeRatingsCount: number;
  deliveriesCount: number;
  totalDistance?: number;
  startTime: string;
  endTime: string;
  comments: string[];
}

export async function fetchCourierRating(
  date: string
): Promise<CourierDailyRating | null> {
  try {
    const response: Response = await Fetch.get({
      url: `${settings.newApiUrl}/courier/my-rating?date=${date}`,
    });

    return response.ok ? await response.json() : null;
  } catch (e) {
    console.log(`Error fetching courier rating`, e);
    return null;
  }
}
